// Base class
import BaseAPIService from './BaseAPIService'

// Config
import endpoints from '@/config/endpoints'
import { localeToDomainMap } from '@/config'
import YoonlyService from '@/services/YoonlyService'

// Types
import { PagemetaTag, PagemetaTagsResponse } from './PagemetaService.interface'
import { Locale } from '@/types'
class PagemetaService extends BaseAPIService {
  constructor() {
    super(endpoints.pagemeta)
  }

  public async getProductURL(liheId: number): Promise<string> {
    if (!liheId)
      throw new Error(
        `[PagemetaService] - getProductURL lihe id must be provided`
      )
    try {
      const locale: Locale = this.getLegacyLocale()
      const payload: Record<string, string | string[]> = {
        locale,
        category: 'ProductPage',
        tags: [`liheId_${liheId}`],
      }

      const { data } = await this.apiClient.post<PagemetaTagsResponse>(
        '/find/tag',
        payload
      )

      this.validateResponse(data)

      const urlPath: string = data[0].urlPath

      if (!urlPath)
        throw new Error(
          '[PagemetaService] - getProductURL ERROR: urlPath cannot be undefined'
        )

      // When on Yoonly domain, use current origin; otherwise use Travelski domain from locale
      const isYoonly = new YoonlyService().isYoonly
      const path = isYoonly
        ? `${window.location.origin}${urlPath}`
        : `https://${localeToDomainMap[locale]}${urlPath}`
        
      return path
    } catch (err) {
      if (err instanceof Error) {
        throw new Error(
          `[PagemetaService] - getProductURL ERROR: ${err.message}`
        )
      }
      throw err
    }
  }

  private validateResponse(data: PagemetaTagsResponse): void {
    if (!data || !Array.isArray(data) || !data.length)
      throw new Error(`[PagemetaService] - validateResponse - invalid data `)
  }
}

export default PagemetaService
